import { makeStyles } from "@material-ui/core"
import { colors } from "../../../../utils/theme"

/**
 * Shared MUI styles used across the safety plan option components
 * (TextBoxOption, SelectAllOption, RadioOption, ContactOption, etc.).
 */
const useSafetyPlanOptionStyles = makeStyles(() => ({
  textBoxContainer: {
    display: "flex",
    minHeight: "52px",
    padding: "16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
    borderRadius: "4px",
  },
  optionContainer: {
    display: "flex",
    minHeight: "52px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
    borderRadius: "4px",
    background: "var(--opacities-black-3, rgba(0, 0, 0, 0.03))",
    padding: "16px",
  },
  optionTxt: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "20px",
    color: colors.safetyPlan.midnight,
  },
  btnText: {
    color: colors.primary.shadow,
    textAlign: "center",
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "24px",
  },
  modalContainer: {
    display: "flex",
    width: "367px",
    padding: "32px 24px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
    borderRadius: "12px",
    background: colors.neutral.white,
  },
  modalBody: {
    display: "flex",
    paddingRight: "8px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
    flexDirection: "column",
  },
  modalField: {
    display: "flex",
    padding: "4px 0px 4px 16px",
    alignItems: "flex-start",
    flex: "1 0 0",
    alignSelf: "stretch",
    borderRadius: "4px 4px 0px 0px",
  },
  modalFooter: {
    display: "flex",
    paddingTop: "8px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
    alignSelf: "stretch",
    background: colors.safetyPlan.grayscale.white75,
    backdropFilter: "blur(4px)",
  },
  cancelModalBtn: {
    display: "flex",
    height: "32px",
    padding: "0px 20px 4px 20px",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
    alignSelf: "stretch",
    borderRadius: "200px",
    textTransform: "none",
    "&:hover": {
      background: "none",
    },
  },
  saveModalBtn: {
    display: "flex",
    height: "52px",
    padding: "4px 32px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
    borderRadius: "200px",
    background: colors.primary.shadow,
    marginLeft: "0px !important",
    textTransform: "none",
    "&:hover": {
      background: colors.primary.shadow,
    },
  },
  modalBtnTxt: {
    textAlign: "center",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "24px",
  },
  plusColor: {
    color: colors.primary.shadow,
  },
  addPlaceModalBtn: {
    display: "flex",
    height: "52px",
    padding: "4px 32px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
    borderRadius: "200px",
    border: `2px solid ${colors.primary.shadow}`,
    background: colors.safetyPlan.grayscale.white75,
    textTransform: "none",
  },
  addPlaceDialogActionTxt: {
    color: colors.primary.shadow,
    textAlign: "center",
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "24px",
  },
}))

export default useSafetyPlanOptionStyles
